import * as React from 'react';

import * as style from './Header.css';

interface IHeaderProps {
  ref?: React.Ref<HTMLDivElement>;
}

function Header({ children, ref }: React.PropsWithChildren<IHeaderProps>): React.JSX.Element {
  return (
    <div ref={ref} className={style['header']}>
      {children}
    </div>
  );
}

export { Header };
